import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import { navModule } from './modules/nav';
import { homeModule } from './modules/home';
import { authModule } from './modules/auth';
import { iconsModule } from './modules/icons';

export default createApp({
  features: [catalogPlugin, navModule, homeModule, authModule, iconsModule],
});
